export default __webpack_public_path__ + "static/pegoraro-d7d12165ae00e13f5790f1afdafb693c.jpeg";